import UserListingContainer from "./UserListingContainer";

export default UserListingContainer;
